import { Grid, TextField, makeStyles } from '@material-ui/core'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { CLIENT_BILLING_FORM_NAMES } from './helpers'

const useStyles = makeStyles(() => ({
  titleInput: {
    fontSize: '1.5rem'
  },
  textField: {
    '& p': {
      color: '#898D9B',
      fontSize: '0.625rem'
    }
  },
  input: {
    fontSize: '0.875rem',
    height: '1.8rem'
  },
  inputLabel: {
    color: '#141929',
    fontSize: '0.875rem',
    fontWeight: 600,
    '& span': {
      color: '#D44333'
    }
  }
}))

const ClientForm = () => {
  const classes = useStyles()
  const { register, formState: { errors } } = useFormContext()

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextField
            label='Long Name'
            fullWidth
            required
            className={classes.textField}
            helperText='80 max characters'
            error={Boolean(errors.longName)}
            inputProps={register(CLIENT_BILLING_FORM_NAMES.longName, {
              required: 'Long name required',
              maxLength: 80,
              minLength: 1
            })}
            InputProps={{
              classes: {
                input: classes.titleInput
              }
            }}
            InputLabelProps={{
              className: classes.inputLabel
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label='Short Name'
            fullWidth
            required
            className={classes.textField}
            helperText='30 max characters'
            error={Boolean(errors.shortName)}
            inputProps={register(CLIENT_BILLING_FORM_NAMES.shortName, {
              required: 'Short name required',
              maxLength: 30,
              minLength: 1
            })}
            InputProps={{
              classes: {
                input: classes.input
              }
            }}
            InputLabelProps={{
              className: classes.inputLabel
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label='Wealth Mission'
            fullWidth
            className={classes.textField}
            helperText='100 max characters'
            error={Boolean(errors.description)}
            inputProps={register(CLIENT_BILLING_FORM_NAMES.description, {
              maxLength: 100,
              minLength: 1
            })}
            InputProps={{
              classes: {
                input: classes.input
              }
            }}
            InputLabelProps={{
              className: classes.inputLabel
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label='Client Abbreviation'
            fullWidth
            className={classes.textField}
            helperText='3 max characters'
            error={Boolean(errors.clientAbbreviation)}
            inputProps={register(CLIENT_BILLING_FORM_NAMES.clientAbbreviation, {
              maxLength: 3,
              minLength: 1
            })}
            InputProps={{
              classes: {
                input: classes.input
              }
            }}
            InputLabelProps={{
              className: classes.inputLabel
            }}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default ClientForm
